class OhsBixPermissions {
  edit_report: boolean;

  constructor(flag: boolean) {
    this.edit_report = flag;
  }
}

export default OhsBixPermissions;
